import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

interface FAQItem {
  question: string
  answer: string
}

const FAQ = () => {
  const [openItems, setOpenItems] = useState<number[]>([])

  const faqItems: FAQItem[] = [
    {
      question: "Er tjenesten virkelig gratis?",
      answer: "Ja, tjenesten er 100% gratis. Der er ingen skjulte omkostninger, abonnementer eller gebyrer. Vi tjener ikke penge på denne service - det er et gratis værktøj for at hjælpe danske borgere med at finde læge."
    },
    {
      question: "Hvordan fungerer Telegram notifikationerne?",
      answer: "Når du starter en chat med vores bot og tilføjer en læge URL, overvåger vi dagligt om lægen åbner for nye patienter. Hvis status ændres til 'åben for nye patienter', sender vi dig en øjeblikkelig besked via Telegram."
    },
    {
      question: "Hvor ofte checker I læge tilgængelighed?",
      answer: "Vi checker alle tilføjede læger én gang dagligt kl. 05:00. Dette sikrer, at du får besked samme dag hvis din læge åbner for nye patienter, så du kan nå at booke en tid."
    },
    {
      question: "Hvilke data opbevarer I om mig?",
      answer: "Vi opbevarer kun dit Telegram chat ID og de læge URLs du har tilføjet. Vi gemmer ikke dit navn, telefonnummer eller andre personlige oplysninger. Du kan til enhver tid slette dine data ved at skrive til botten."
    },
    {
      question: "Kan jeg overvåge flere læger samtidig?",
      answer: "Ja, du kan tilføje så mange læge URLs som du ønsker. Botten vil overvåge dem alle og sende dig notifikationer når nogen af dem åbner for nye patienter."
    },
    {
      question: "Hvad hvis jeg ikke har Telegram?",
      answer: "Du skal bruge Telegram for at modtage notifikationer. Telegram er gratis og kan downloades til alle smartphones. Du kan downloade det fra telegram.org/apps. Det tager kun et par minutter at oprette en konto."
    },
    {
      question: "Hvordan stopper jeg notifikationer?",
      answer: "Du kan til enhver tid stoppe notifikationer ved at skrive til botten. Du kan fjerne specifikke læger eller slette alle dine data. Der er ingen binding eller kontrakt."
    },
    {
      question: "Virker det med alle læger på findlæge.dk?",
      answer: "Ja, vores system kan overvåge alle læger der er listet på findlæge.dk. Send bare URL'en til den specifikke læge til vores bot, så starter vi overvågningen."
    },
    {
      question: "Hvor hurtigt får jeg besked?",
      answer: "Du får besked inden for få minutter efter at lægens status ændres til 'åben for nye patienter'. Notifikationen sendes direkte til din Telegram app."
    },
    {
      question: "Er der en grænse for hvor mange notifikationer jeg kan få?",
      answer: "Nej, der er ingen grænse. Du får en notifikation hver gang en af dine overvågede læger åbner for nye patienter. Hvis en læge lukker og åbner igen, får du en ny notifikation."
    }
  ]

  const toggleItem = (index: number) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    )
  }

  return (
    <section className="section-padding bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ofte stillede spørgsmål
          </h2>
          <p className="text-xl text-gray-600">
            Find svar på de mest almindelige spørgsmål om vores læge notifikationstjeneste
          </p>
        </div>
        
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {item.question}
                </h3>
                {openItems.includes(index) ? (
                  <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" />
                )}
              </button>
              
              {openItems.includes(index) && (
                <div className="px-6 py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-primary/5 border border-primary/20 rounded-xl p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Har du andre spørgsmål?
            </h3>
            <p className="text-gray-600 mb-6">
              Hvis du ikke kan finde svar på dit spørgsmål her, er du velkommen til at kontakte os via Telegram botten.
            </p>
            <button className="btn-primary">
              Kontakt os via Telegram
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ